import { dashBoardConstants } from '../../_constants/dashBoard.constants';

const initialState = { dash_board_data_loading : true, dash_board_data: '', dash_board_data_error: false};

export function dashBoardRed(state = initialState, action) {
    switch (action.type) {
        case dashBoardConstants.REQUEST_DASH_BOARD_DATA:
        return {
            dash_board_data_loading: true,
            dash_board_data: '',
            dash_board_data_error: false
        };
      case dashBoardConstants.RECIEVE_DASH_BOARD_DATA:
        return {
            dash_board_data_loading: false,
            dash_board_data: action.dash_board_data,
            dash_board_data_error: false
        };
      case dashBoardConstants.ERROR_DASH_BOARD_DATA:
        return { 
            dash_board_data_loading: false,
            dash_board_data: '',
            dash_board_data_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/dashBoard/dashBoard.reducer.js